import {Box, SortDirection, SxProps} from '@mui/material';
import React, {FC, useCallback, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {selectNonAgentUsers} from 'state/features/api/user-slice';
import {selectPageSettingByKey} from '../../../../state/features/page-header-setting/page-header-setting-slice';
import {theme} from '../../../../styles/theme';
import {filterListItems, sortListItems} from '../../../../utilities/helpers/general-helpers';
import {VirtualizedContentBoxList} from '../../../components/default-components/virtual-content-box-list/virtual-content-box-list';
import {UserManagementBoxItem} from './user-management-box-item';

export const UserManagementBoxView: FC = React.memo(() => {
  const pageSetting = useSelector(selectPageSettingByKey('userManagement'));

  const users = useSelector(selectNonAgentUsers);

  const filteredItems = useMemo(() => {
    const filteredArray = filterListItems(users, ['name'], pageSetting?.searchString);
    return sortListItems(filteredArray, 'name', pageSetting ? (pageSetting.sort as SortDirection) : 'asc').map(
      (user) => user.id!,
    );
  }, [pageSetting, users]);

  const renderUserManagementBoxItem = useCallback(
    ({index}: any) => {
      if (index > filteredItems.length - 1) {
        return null;
      }
      return <UserManagementBoxItem key={filteredItems[index]} userId={filteredItems[index]} />;
    },
    [filteredItems],
  );

  return (
    <Box sx={{marginTop: theme.spacing(3)} as SxProps}>
      <VirtualizedContentBoxList items={filteredItems} rowRenderer={renderUserManagementBoxItem} />
    </Box>
  );
});
